import { ScopeOption } from '../types';

/** Зона данных по аптекам: документ попадает в зону, если отправитель ИЛИ получатель - аптека из зоны */
const zoneScope = (what: string): ScopeOption[] => [
  { value: 'all', label: 'Все документы', description: `${what}: вся сеть`, badgeColor: '#10b981' },
  { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: `${what}: документы аптек из myPharmacy оператора`, badgeColor: '#3b82f6' },
  { value: 'own_region', label: 'Свой регион', description: `${what}: документы аптек своего города (cityId)`, badgeColor: '#06b6d4' },
  { value: 'none', label: 'Запрещено', description: `${what}: нет доступа`, badgeColor: '#ef4444' }
];

/**
 * Варианты скоупов для модуля «Документы и табели» (documents.*)
 */
export const documentsScopes: Record<string, ScopeOption[]> = {
  // Документы: что видит оператор
  'documents.invoices.view': zoneScope('Просмотр документов'),

  // Документы: на какие документы можно запускать повторную обработку (может быть уже, чем просмотр)
  'documents.invoices.retry': zoneScope('Повторная обработка'),

  // Остальные действия над документом: каждое - в своей зоне (документ должен входить и в зону просмотра, и в зону действия)
  'documents.invoices.hide': zoneScope('Скрытие / возврат документов'),
  'documents.invoices.reject': zoneScope('Отклонение документов'),
  'documents.invoices.delete_draft': zoneScope('Удаление черновиков'),
  'documents.invoices.export_1c': zoneScope('Выгрузка накладных в 1С'),

  // Проблемные документы на контроле: зона вкладки (пересекается с зоной просмотра) и отдельно - что можно делать
  'documents.invoices.warnings': zoneScope('Проблемные документы на контроле'),
  'documents.invoices.warnings_actions': [
    { value: 'view', label: 'Только просмотр', description: 'Видит документы, которые скоро будут отменены или скрыты, без возможности продлить срок', badgeColor: '#3b82f6' },
    { value: 'view_extend', label: 'Просмотр + редактирование', description: 'Видит такие документы и может продлевать срок до автоотмены (в зоне вкладки)', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключено', description: 'Как «Только просмотр»: действий над документами во вкладке нет', badgeColor: '#94a3b8' }
  ],

  // Аналитика: зона расчёта (пересекается с зоной просмотра документов)
  'documents.invoices.analytics': zoneScope('Аналитика документов'),
  'documents.invoices.analytics_timeline': zoneScope('Аналитика: Динамика'),
  'documents.invoices.analytics_leadtime': zoneScope('Аналитика: Сроки обработки'),
  'documents.invoices.analytics_pharmacies': zoneScope('Аналитика: Аптеки'),
  'documents.invoices.analytics_heatmap': zoneScope('Аналитика: Активность по часам'),
  'documents.invoices.analytics_cleanup': zoneScope('Аналитика: Автоочистка'),
  'documents.invoices.analytics_products': zoneScope('Аналитика: Товар'),

  // Настройки документов (шестерёнка): правила сети + исключения. Не в зоне - только просмотр правил сети
  'documents.invoices.settings': [
    { value: 'all', label: 'Вся сеть', description: 'Настройки документов: правила сети (просмотр и изменение) и исключения любых аптек', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Правила сети - только просмотр; исключения - для аптек из myPharmacy оператора', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Правила сети - только просмотр; исключения - для аптек своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Настройки документов: нет доступа', badgeColor: '#ef4444' }
  ]
  // Булевы права (view_doc_amount, view_item_amounts, view_marks, view_series, view_history, view_audit, export, export_marks, warnings_export) скоупов не имеют - только тумблер
};
